/**
 * Brand Logo Slider
 */
import React, { Component } from 'react';
import Slider from "react-slick";
import { Col } from 'reactstrap';

const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };

class BrandLogoSlider extends Component {
   render() {
    return (
            <Col sm={12}>
                <div className="ciyashop_clients ciyashop_clients-list-type-slider">
                   <Slider {...settings} className="slider-arrow-hover">
                           <div className="item">
                               <img className="img-fluid mx-auto" src={require(`../assets/images/clients/01.png`)}  alt="clients-logo" />
                            </div>
                            <div className="item">
                                <img className="img-fluid mx-auto"  src={require(`../assets/images/clients/02.png`)}  alt="clients-logo" />
                            </div>
                            <div className="item">
                                 <img className="img-fluid mx-auto"  src={require(`../assets/images/clients/03.png`)}  alt="clients-logo" />
                            </div>
                            <div className="item">
                                 <img className="img-fluid mx-auto"  src={require(`../assets/images/clients/04.png`)}  alt="clients-logo" />
                            </div>
                            <div className="item">
                                  <img className="img-fluid mx-auto"  src={require(`../assets/images/clients/05.png`)}  alt="clients-logo" />
                            </div>
                            <div className="item">
                                 <img className="img-fluid mx-auto"  src={require(`../assets/images/clients/06.png`)}  alt="clients-logo" />
                            </div>
                            <div className="item">
                                <img className="img-fluid mx-auto"  src={require(`../assets/images/clients/07.png`)}  alt="clients-logo" />
                            </div>
                            <div className="item">
                                 <img className="img-fluid mx-auto"  src={require(`../assets/images/clients/08.png`)}  alt="clients-logo" />
                            </div>
                            <div className="item">
                                <img className="img-fluid mx-auto"  src={require(`../assets/images/clients/09.png`)}  alt="clients-logo" />
                            </div>
                    </Slider>
                </div>
            </Col>
      )
   }
}

export default BrandLogoSlider;
